<template>
  <div class="u-audio-attach" :class="uName">
    <!--icon-audio_pause-->
    <!--icon-audio_err-->
    <!--icon-audio_loading-->
    <button class="iconfont  left "
            :class="{'icon-bofangshipin':status===1 || status ===5 || status ===0,'icon-chucuo':status === 3,'icon-shunshizhenfangxiangclockwise4':status === 2,'icon-audio_pause':status === 4 }"

            @click="onTogglePlay"></button>
    <!--<progress>sdfsdf</progress>-->

    <span class="middle"> <UProgressBar :percent="percent" @percentChange="onProgressBarChange"></UProgressBar></span>
    <span class="right">{{format(restDuration)}}</span>
    <audio :src="filePath" ref="audio" @playing="onPlaying" @play="onReady" @error="onErr"
           @timeupdate="onUpdateTime"
           @ended="onEnd"></audio>
  </div>

</template>

<script type="text/ecmascript-6">
  import UProgressBar from './uProgressBar/uProgressBar'
  import mixin from './attachMixin'
  // 音频未加载
  const AUDIOSTATUSUNLOAD = 0
  //  音频暂停
  const AUDIOSTATUSPAUSE = 1
  //  音频加载中
  const AUDIOSTATUSLODING = 2
  //  音频加载错误
  const AUDIOSTATUSLODERR = 3
  //  音频播放中
  const AUDIOSTATUSPLAYING = 4
  //  音频播放完成
  const AUDIOSTATUSEND = 5
  let destroy = false

  export default {
    mixins: [mixin],
    data () {
      return {
        filePath: this.uFilePath,
//         总时长
        totalDuration: 0,
//         当前播放时长
        currentDuration: 0,
//        音频的初始状态，是未加载
        status: AUDIOSTATUSUNLOAD,
      }
    },
    created () {
      destroy = false
    },
    destroyed () {
      destroy = true
    },
    methods: {
      onTogglePlay: function () {
//        音频未加载
        if (this.status === AUDIOSTATUSUNLOAD) {
          this.$refs.audio.play()
        } else if (this.status === AUDIOSTATUSLODERR) {
//          上次加载错误，再次执行加载音频
          this.$refs.audio.play()
        } else if (this.status === AUDIOSTATUSPAUSE) {
//          音频暂停
          this.$refs.audio.play()
        } else if (this.status === AUDIOSTATUSLODING) {
//          音频加载中
        } else if (this.status === AUDIOSTATUSPLAYING) {
//    音频播放中
          this.$refs.audio.pause()
          this.status = AUDIOSTATUSPAUSE
        } else if (this.status === AUDIOSTATUSEND) {
//          音频播放完成
          // this.$refs.audio.clear()
          this.$refs.audio.play()
        }
      },
//    开始加载的回调
      onReady: function () {
        this.totalDuration = this.$refs.audio.duration
//        音频状态开始在加载中
        this.status = AUDIOSTATUSLODING
      },
      onPlaying: function () {
        this.status = AUDIOSTATUSPLAYING
      },
      onErr: function () {
        this.status = AUDIOSTATUSLODERR
      },
      onUpdateTime: function () {
//        this.status = AUDIOSTATUSPLAYING
        if (destroy) return
        this.currentDuration = this.$refs.audio.currentTime
      },
      onEnd: function () {
        if (this) {
          this.status = AUDIOSTATUSEND
        }
      },
      onProgressBarChange: function (percent) {
        let currentTime = this.totalDuration * percent
        this.$refs.audio.currentTime = currentTime
        this.$refs.audio.play()
      },
      format (interval) {
        interval = interval | 0
        const minute = interval / 60 | 0
        const second = this._pad(interval % 60)
        return `${minute}:${second}`
      },
      _pad (num, n = 2) {
        let len = num.toString().length
        while (len < n) {
          num = '0' + num
          len++
        }
        return num
      },
      // 快进
      fastForward: function () {
        this.$refs.audio.currentTime += 15
      },
      // 快退
      fastBackward: function () {
        if(this.$refs.audio.currentTime <= 15){
          this.$refs.audio.currentTime = 0
        }else{
          this.$refs.audio.currentTime -= 15
        }
      },
      handleMedia: function (type) {
        console.log(type+'--audio')
        if(type == 1){
          this.onTogglePlay()
        }else if(type == 2){
          this.fastForward()
        }else if(type == 3){
          this.fastBackward()
        }
      }
    },
    computed: {
      restDuration: function () {
        return this.totalDuration - this.currentDuration
      },
      percent: function () {
        return this.currentDuration / this.totalDuration
      }
    },
    components: {
      UProgressBar
    }
  }
</script>

<style scoped lang="scss">
  button{
    background: none;
    border: none;
    &:focus,
    &:active,
    &::selection{
      outline: none;
    }
  }
  .u-audio-attach{
    display: flex;
    align-items: center;
    justify-content: space-between;
    height: 56px;
    border-radius: 28px;
    border: 1px solid #e3e3e9;
    padding: 0px 28px;
    box-shadow : 0 4px 8px 0 rgba(216,216,216,0.4);
    background-color: #fff;
    .left{
      display : inline-block;
      width: 28px;
      height : 100%;
      border-right: 1px solid #e3e3e9;
      font-size: 16px;
      text-align: left;
      color: #ea5947;
      &:before{
        color: #ea5947;
      }
    }
    .middle{
      flex: 1;
      margin-left: 8px;
      margin-right: 8px;
    }
    .right{
      font-size: 12px;
      color: #969696;
    }
  }
</style>



// WEBPACK FOOTER //
// src/common/components/uAttach/uAudioAttach.vue